import React from 'react';
import CTAButton from '../ctaButton/CTAButton';
import PropTypes from 'prop-types';

import downloadWhite from '../../../content/media-library/download-white.svg';

const FeaturedVideoContent = ({
  preTitle,
  title,
  subtitle,
  callToAction,
  backgroundVideoId,
  backgroundVideoPreview,
  arrowDown,
  fallbackImage,
  award,
  hideMask
}) => {
  const scrollDown = (e) => {
    e.preventDefault();
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: document.getElementById('scroll-section').offsetTop - 120
    });
  };

  return (
    <section className="featured-content--with-video">
      <div className="background-video">
        {hideMask !== 'true' && <div className="video-mask" />}
        <div className="video" style={fallbackImage && { backgroundImage: `url(${fallbackImage})` }}>
          <video
            className="video_element"
            playsInline
            autoPlay
            muted
            loop
            poster={backgroundVideoPreview ? backgroundVideoPreview : null}
            controls
          >
            <source
              src={`https://media.starlingbank.com/videos/${backgroundVideoId}.webm`}
              type="video/webm; codecs=vp9,vorbis"
            />
            <source src={`https://media.starlingbank.com/videos/${backgroundVideoId}.mp4`} type="video/mp4" />
          </video>
        </div>
      </div>
      <div className="featured-content__text-block">
        {preTitle ? <p className="featured-content__pretitle">{preTitle}</p> : null}
        {title ? <h1 className="featured-content__title" dangerouslySetInnerHTML={{ __html: title }} /> : null}
        {subtitle ? <p className="featured-content__subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} /> : null}
        {callToAction ? <CTAButton {...callToAction} /> : null}
        {award ? (
          <a href={award.href} target="_blank" rel="noopener noreferrer">
            <img key={award.alt || award.src} className="featured-content__award" src={award.src} alt={award.alt} />
          </a>
        ) : null}
        {arrowDown ? (
          <a href="#scroll-section" className="featured-content__button" onClick={(e) => scrollDown(e)}>
            <span className="screen-reader-text">Skip to main content</span>
            <img className="down-button" alt="Down arrow" src={downloadWhite} />
          </a>
        ) : null}
      </div>
    </section>
  );
};

FeaturedVideoContent.propTypes = {
  preTitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  callToAction: PropTypes.shape(CTAButton.propTypes),
  backgroundVideoId: PropTypes.string,
  backgroundVideoPreview: PropTypes.string,
  arrowDown: PropTypes.oneOf(['white']),
  fallbackImage: PropTypes.string,
  award: PropTypes.object,
  hideMask: PropTypes.string
};

export default FeaturedVideoContent;
